import React, { useState } from 'react';
import Card from '../cards/Card';
import styles from './styles.module.scss';
import Avatar from '@material-ui/core/Avatar';
import PropTypes from 'prop-types';
import DefaultAvatar from '../../../assets/icons/svgIcons/avatar.svg';
import { parseDate } from '../../../helpers/date';
import { IconButton, TextField, Button } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ReplyCommentDialog from '../../_dialogContent/ReplyCommentDialog';
import {
  addContentAction,
  closeSliderDialogAction,
  openSliderDialogAction,
  addFabAction
} from '../../../reactRedux/Actions/showSliderDialogAction';
import { useDispatch } from 'react-redux';
import { modules } from '../../../helpers/modules';
import { useTranslation } from '../../../i18n/LanguageProvider';

const Comment = ({
  onProfileClick,
  senderUser,
  createdAt,
  editable,
  onEditComment,
  onDeleteComment,
  loading,
  comment,
  kudosId,
  commentId,
  ...props
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [editMode, setEditMode] = useState(false);
  const [editedComment, setEditedComment] = useState(comment);

  const [anchorEl, setAnchorEl] = useState(null);
  const openSliderDialog = () => dispatch(openSliderDialogAction());
  const closeDialog = () => dispatch(closeSliderDialogAction());
  const setDialogContent = (content) => dispatch(addContentAction(content));
  const setDialogFab = (fab) => dispatch(addFabAction(fab));

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    if (e.currentTarget.id === 'delete') {
      onDeleteComment();
    }
    if (e.currentTarget.id === 'edit') {
      setEditMode(true);
    }
    setAnchorEl(null);
  };

  const handleSubmitComment = () => {
    onEditComment(editedComment);
    setEditMode(false);
  };

  const handleCancelEdit = () => {
    setEditedComment(comment);
    setEditMode(false);
  };

  const setDialog = () => {
    setDialogFab([
      {
        type: 'default',
        isClose: true,
        iconOnly: true,
        onClickFn: closeDialog
      }
    ]);
    setDialogContent(
      <ReplyCommentDialog kudosId={kudosId} commentId={commentId} />
    );
    openSliderDialog();
  };

  return (
    <Card {...props}>
      <div className={styles.wrapper}>
        <div className={styles.body}>
          <div className={styles.info}>
            <div className={styles.pics} onClick={onProfileClick}>
              <Avatar
                alt={senderUser.first_name}
                src={senderUser.avatar || DefaultAvatar}
                className={styles.small}
              />
              <span>
                {`${senderUser.first_name} ${senderUser.last_name}`}
                <div className={styles.time}>{parseDate(createdAt)}</div>
              </span>
            </div>
          </div>
          {editable && (
            <div className={styles.icon}>
              <IconButton
                aria-label="more"
                onClick={handleClick}
                aria-haspopup="true"
                aria-controls="long-menu"
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                onClose={handleClose}
                open={open}
              >
                <MenuItem id={'delete'} onClick={handleClose}>
                  {t('common.delete')}
                </MenuItem>
                <MenuItem id={'edit'} onClick={handleClose}>
                  {t('common.edit')}
                </MenuItem>
              </Menu>
            </div>
          )}
        </div>

        {editMode ? (
          <div className={styles.edit}>
            <TextField
              id="comment"
              className={styles.input}
              name="comment"
              type="text"
              multiline
              hiddenLabel
              onChange={(e) => setEditedComment(e.target.value)}
              value={editedComment}
            />
            <Button
              onClick={handleSubmitComment}
              variant="contained"
              style={{ marginInlineEnd: '16px' }}
              disabled={loading}
              size="small"
            >
              {t('common.confirm')}
            </Button>
            <Button onClick={handleCancelEdit} variant="outlined" size="small">
              {t('common.cancel')}
            </Button>
          </div>
        ) : (
          <div className={styles.note} dir="auto">
            {comment}
          </div>
        )}
        {modules.replyComment && (
          <div className={styles.reply} onClick={setDialog}>
            {t('comments.reply')}
          </div>
        )}
      </div>
    </Card>
  );
};

Comment.propTypes = {
  onProfileClick: PropTypes.func,
  commentId: PropTypes.id,
  kudosId: PropTypes.id,
  senderUser: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    avatar: PropTypes.string
  }),
  createdAt: PropTypes.string,
  editable: PropTypes.bool,
  onEditComment: PropTypes.func,
  onDeleteComment: PropTypes.func,
  loading: PropTypes.bool,
  comment: PropTypes.string
};

export default Comment;
